import React from "react";
import { ShieldCheck } from "lucide-react";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen flex bg-canvas">
      <main
        data-testid="auth-shell"
        className="flex-1 flex items-center justify-center px-6 py-10"
      >
        <div className="w-full max-w-md">
          <div className="flex items-center gap-2.5 mb-10">
            <div className="h-9 w-9 rounded-full bg-primary flex items-center justify-center">
              <ShieldCheck className="h-5 w-5 text-white" strokeWidth={2.2} />
            </div>
            <div>
              <div className="text-lg font-semibold leading-none tracking-tight text-zinc-900">
                Signa
              </div>
              <div className="text-[10px] uppercase tracking-[0.14em] text-zinc-900/40 mt-1">
                ЭЦП · Платформа документооборота
              </div>
            </div>
          </div>

          <h1 className="text-2xl font-semibold tracking-tight text-zinc-900">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-2 text-sm text-zinc-500 leading-relaxed">
              {subtitle}
            </p>
          )}

          <div className="mt-8">{children}</div>

          {footer && (
            <div className="mt-6 text-sm text-zinc-500">{footer}</div>
          )}
        </div>
      </main>
    </div>
  );
}
